<template>
  <v-dialog
    :return-value.sync="date"
    ref="dialog"
    v-model="modal"
    width="290px"
  >
    <template v-slot:activator="{ on }">
      <transition name="slide-y-transition">
        <v-text-field
          v-model="date"
          :label="label"
          :prepend-inner-icon="prependInnerIcon"
          :clearable="clearable"
          readonly
          @click.native="modal = true"
          :outlined="specialStyle || outlined"
          :filled="filled"
          :dense="dense"
          :hide-details="hideDetails"
          :background-color="specialStyle ? 'white': ''"
          :disabled="disabled"
          @click:clear="clearFc()"
        ></v-text-field>
      </transition>
    </template>
    <v-date-picker v-model="date" scrollable :allowed-dates="allowedDates">
      <v-spacer></v-spacer>
      <v-btn text color="blue darken-1" @click="$refs.dialog.save(date); handleDataFc()">OK</v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
    export default {
      name: "DatePicker",
      props: {
        label: String,
        clearable: Boolean,
        disabled: Boolean,
        specialStyle: Boolean,
        outlined: Boolean,
        filled: Boolean,
        dense: Boolean,
        hideDetails: { type: [Boolean, String], default: false },
        allowedDates: Function,
        rules: Array,
        date_props: String,
        prependInnerIcon: String,
        default () {
          return ''
        }
      },
      data () {
        return {
          date: this.date_props,
          modal: false
        }
      },
      methods : {
        handleDataFc : function () {
          this.$emit('interface', this.date);
        },
        clearFc : function () {
          this.$emit('interface', null);
        },
        clear(){
          this.date = null;
        },
        setDate(newDate){
          this.date = newDate;
        },
      },
      beforeMount() {
        this.date = this.date_props;
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/parts/DatePicker.vue